import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CreationProjetService } from '../creation-projet.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BroadcastService } from 'app/broadcast.service';
import { MessageNotification } from 'app/modules/models/messageNotification.type';
import { catchError, EMPTY, exhaustMap, Subject, Subscription, takeUntil, timer } from 'rxjs';

@Component({
  selector: 'app-redirection-pop-up',
  templateUrl: './redirection-pop-up.component.html',
  styleUrls: ['./redirection-pop-up.component.scss']
})
export class RedirectionPopUpComponent implements OnInit, OnDestroy {
  isSaved = false;
  isExtracted = false;
  isUploading: boolean;
  draftProgressPercent: number | null = null;
  draftProgressMessage: string | null = null;
  private stopPolling$ = new Subject<void>();
  private draftProgressSubscription?: Subscription;
  private hasRedirectStarted = false;
  private redirectTimeout?: ReturnType<typeof setTimeout>;
  project: any;

  constructor(private router: Router,
    private readonly _snackBar: MatSnackBar,
    private _creationProjetService: CreationProjetService,
    private readonly _broadcastService: BroadcastService,
    public dialogRef: MatDialogRef<RedirectionPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      id: string;
      waitForDraftProcessing?: boolean;
      refreshAfterProcessing?: boolean;
    }


  ) { }

  ngOnInit(): void {
    if (this.data.waitForDraftProcessing) {
      this.draftProgressSubscription = this._broadcastService.documentDraftProgress$.subscribe(notification => {
        this.handleDocumentDraftProgressNotification(notification);
      });
    }

    // Keep polling as a completion fallback in case a real-time progress
    // notification is missed while the dialog is being created.
    this.startExtraction(this.data.id);
  }

  ngOnDestroy(): void {
    this.stopPolling();
    this.draftProgressSubscription?.unsubscribe();
    clearTimeout(this.redirectTimeout);
  }

  // saveToDatabase() {
  //   this._creationProjetService.depotProjectFinancement(
  //     this.data.company.id,
  //     this.data.partnerId,
  //     this.data.formData,
  //     this.data.mandateId,
  //     this.data.partnerName,
  //     this.data.mandateName
  //   ).subscribe({
  //     next: res => {
  //       this.project = res;
  //       this._snackBar.open('Projet créé avec succès', null, { duration: 2000, panelClass: 'accent-snackbar' });
  //       this.isSaved = true;

  //     },
  //     error: err => {
  //       this._snackBar.open('Une erreur est survenue lors de la creation du projet', null, { duration: 2000, panelClass: 'accent-snackbar' });
  //     },
  //   });
  // }

  startExtraction(projet_Id) {
    timer(0, 3000)
      .pipe(
        exhaustMap(() =>
          this._creationProjetService.checkIfProjectExtractionIsSaved(projet_Id)
            .pipe(
              catchError(err => {
                this._snackBar.open(
                  'Une erreur est survenue lors de la vérification du projet',
                  undefined,
                  { duration: 2000, panelClass: 'accent-snackbar' }
                );
                this.isExtracted = false;
                return EMPTY; // Retry on the next tick after a transient failure.
              })
            )
        ),
        takeUntil(this.stopPolling$)
      )
      .subscribe(exists => {
        if (exists === true) {
          this.isExtracted = true;
          this.stopPolling(); // stop polling once done
          this.redirectAfterExtractionDone();
        }
      });
  }

  private handleDocumentDraftProgressNotification(notification: MessageNotification): void {
    try {
      const content = notification?.content ? JSON.parse(notification.content) : null;
      if (!content) return;

      const projectId = content?.ProjectId || content?.projectId || null;
      const message = content?.message ?? content?.Message ?? null;
      const progress = Number(content?.progress ?? content?.Progress ?? null);

      if (projectId && projectId === this.data.id && !isNaN(progress)) {
        this.draftProgressPercent = Math.max(0, Math.min(100, Math.round(progress)));
        this.draftProgressMessage = message ? String(message) : null;

        // Progress is informational. Only polling can confirm that the
        // extracted data has been persisted and unlock completion.
      }
    } catch (e) {
      console.error('Failed to parse draft progress notification', e, notification?.content);
    }
  }

  stopPolling() {
    if (!this.stopPolling$.closed) {
      this.stopPolling$.next();
      this.stopPolling$.complete();
    }
  }

  //redirect without waiting to the main project list
  redirectWithoutWaiting() {
    // Close the popup and redirect
    this.stopPolling(); // optional: stop polling immediately
    localStorage.setItem('selectedDossierIndex', "7");
    this.router.navigate(['/partner-dossier-project']); // Adjust route accordingly
    this.dialogRef.close(); // Close the dialog
  }

  // redirect after getting the extraction done
  redirectAfterExtractionDone() {
    if (this.hasRedirectStarted) {
      return;
    }

    this.hasRedirectStarted = true;
    this.redirectTimeout = setTimeout(() => {
      this.dialogRef.close();

      const projectUrl = this.router.serializeUrl(
        this.router.createUrlTree(['/fiche-projet', this.data.id])
      );
      const currentUrl = this.router.url.split('?')[0];

      // A same-route Angular navigation does not recreate the page by default.
      // Force a browser refresh so every form is rebuilt from the newly
      // extracted AH/facture data once DOVA processing has completed.
      if (currentUrl === projectUrl.split('?')[0]) {
        window.location.reload();
        return;
      }

      window.location.assign(projectUrl);
    }, 3000);
  }

}
